module.exports = __webpack_public_path__ + "img/4-2-1-3-1-preview-grabpromo-e.556ae29f.jpg";